import React, {
  useState,
} from "react";

import "../styles/website.css";
import "../styles/contact.css";

import {
  createQueryApi,
} from "../../../api/queries/queries.api";


const ContactPage = () => {

  const [
    submitted,
    setSubmitted,
  ] = useState(false);


  const [
    loading,
    setLoading,
  ] = useState(false);


  const [
    error,
    setError,
  ] = useState(null);


  const [
    formData,
    setFormData,
  ] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    message: "",
  });


  /*
  |--------------------------------------------------------------------------
  | HANDLE INPUT
  |--------------------------------------------------------------------------
  */

  const handleChange = (event) => {

    const {
      name,
      value,
    } = event.target;


    setFormData((current) => ({
      ...current,
      [name]: value,
    }));

  };


  /*
  |--------------------------------------------------------------------------
  | SUBMIT QUERY
  |--------------------------------------------------------------------------
  */

  const handleSubmit = async (event) => {

    event.preventDefault();

    setLoading(true);
    setError(null);


    try {

      /*
      |--------------------------------------------------------------------------
      | QUERY PAYLOAD
      |--------------------------------------------------------------------------
      |
      | POST /queries
      |
      | Backend expects:
      |
      | name
      | email
      | phone
      | subject
      | message
      |
      */

      const payload = {

        name:
          formData.name,

        email:
          formData.email,

        phone:
          formData.phone || null,

        subject:
          formData.service
            ? `Website enquiry - ${formData.service}`
            : "Website enquiry",

        message:
          formData.message,

      };


      console.log(
        "[WEBSITE QUERY] SUBMITTING",
        payload
      );


      const response =
        await createQueryApi(
          payload
        );


      console.log(
        "[WEBSITE QUERY] RESPONSE",
        response
      );


      /*
      |--------------------------------------------------------------------------
      | SUCCESS
      |--------------------------------------------------------------------------
      */

      setSubmitted(true);


      /*
      |--------------------------------------------------------------------------
      | RESET FORM
      |--------------------------------------------------------------------------
      */

      setFormData({
        name: "",
        phone: "",
        email: "",
        service: "",
        message: "",
      });


    } catch (err) {

      console.error(
        "[WEBSITE QUERY] ERROR",
        err
      );


      setError(
        err?.response?.data?.message ||
        err?.message ||
        "Unable to send your message. Please try again."
      );


    } finally {

      setLoading(false);

    }

  };


  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  return (
    <div className="website">

      <main>

        {/* HERO */}

        <section className="inner-hero contact-hero">

          <div>

            <span className="section-label">
              CONTACT US
            </span>

            <h1>
              Let's talk about
              <span> your project.</span>
            </h1>

            <p>
              Have a question, project idea or business
              requirement? Send us a message.
            </p>

          </div>

        </section>


        {/* CONTACT SECTION */}

        <section className="contact-section">

          {/* CONTACT INFORMATION */}

          <div className="contact-info">

            <span className="section-label">
              GET IN TOUCH
            </span>

            <h2>
              We'd love to
              hear from you.
            </h2>

            <p>
              Whether you need a website, business
              application or a complete software platform,
              our team can help you plan the next step.
            </p>


            <div className="contact-details">

              {/* PHONE */}

              <div className="contact-detail">

                <span className="contact-icon">
                  ☎
                </span>

                <div>

                  <small>
                    Phone
                  </small>

                  <a href="tel:8840514251">
                    8840514251
                  </a>

                  <a href="tel:8826882142">
                    8826882142
                  </a>

                </div>

              </div>


              {/* EMAIL */}

              <div className="contact-detail">

                <span className="contact-icon">
                  @
                </span>

                <div>

                  <small>
                    Email
                  </small>

                  <a href="mailto:harshait.support.com">
                    harshait.support.com
                  </a>

                </div>

              </div>

            </div>

          </div>


          {/* CONTACT FORM */}

          <div className="contact-form-wrapper">

            {submitted ? (

              /* SUCCESS */

              <div className="contact-success">

                <div className="success-icon">
                  ✓
                </div>

                <h3>
                  Message received!
                </h3>

                <p>
                  Thank you for contacting Harsha IT.
                  Our team will get back to you.
                </p>

                <button
                  type="button"
                  onClick={() => {
                    setSubmitted(false);
                    setError(null);
                  }}
                >
                  Send Another Message
                </button>

              </div>

            ) : (

              /* FORM */

              <form
                className="contact-form"
                onSubmit={handleSubmit}
              >

                {/* ERROR */}

                {error && (

                  <div className="contact-form-error">
                    {error}
                  </div>

                )}


                {/* NAME + PHONE */}

                <div className="form-row">

                  <div className="form-group">

                    <label>
                      Your Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />

                  </div>


                  <div className="form-group">

                    <label>
                      Phone
                    </label>

                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone"
                    />

                  </div>

                </div>


                {/* EMAIL */}

                <div className="form-group">

                  <label>
                    Email Address
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                  />

                </div>


                {/* SERVICE */}

                <div className="form-group">

                  <label>
                    What do you need?
                  </label>

                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >

                    <option
                      value=""
                      disabled
                    >
                      Select a service
                    </option>

                    <option value="website">
                      Website Development
                    </option>

                    <option value="ecommerce">
                      E-Commerce
                    </option>

                    <option value="inventory">
                      Inventory Management
                    </option>

                    <option value="crm">
                      CRM
                    </option>

                    <option value="multi-tenancy">
                      Multi-Tenancy Platform
                    </option>

                    <option value="custom">
                      Custom Software
                    </option>

                  </select>

                </div>


                {/* MESSAGE */}

                <div className="form-group">

                  <label>
                    Message
                  </label>

                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    placeholder="Tell us about your requirement..."
                    required
                  />

                </div>


                {/* SUBMIT */}

                <button
                  type="submit"
                  className="form-submit"
                  disabled={loading}
                >

                  {loading
                    ? "Sending..."
                    : "Send Message"
                  }

                  {!loading && (
                    <span>
                      →
                    </span>
                  )}

                </button>

              </form>

            )}

          </div>

        </section>

      </main>

    </div>
  );

};


export default ContactPage;